import { FC, useEffect, useRef, useState, memo } from 'react';
import { ReactComponent as CalendarSvg } from 'assets/img/filter/calendar.svg';
import { DatePickerСhoose } from 'components/DateFilter/DatePickerСhoose';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import {
  getBeforeLastMonth,
  getCurrentDay,
  getLastMonth,
  getLastWeek,
  getThreeDay,
  getTitleDateNewFormat,
  getTwoLastWeek,
  getWeek,
} from 'utils/date';
import {
  setDateStart,
  setDateEnd,
  setDateStartPicker,
  setDateEndPicker,
} from 'redux/dateRange/slice';
import styles from './DateFilter.module.scss';
import classNames from 'classnames';
import { capitalizeFirstLetter } from 'utils/strActions';

export const DateFilter: FC = memo(() => {
  const dispatch = useDispatch();
  const { dateStart, dateEnd, dateEndPicker, dateStartPicker, activeHandlerDate } =
    useSelector((state: RootState) => state.dateRange);

  const [nameSelectDate, setNameSelectDate] = useState('week');

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dateTitleRef = useRef<HTMLDivElement>(null);
  const dateRef = useRef<HTMLDivElement>(null);

  const resetDate = () => {
    if (dateStartPicker && !dateEndPicker) {
      dispatch(setDateStartPicker(dateStart ? new Date(dateStart) : null));
      dispatch(setDateEndPicker(dateEnd ? new Date(dateEnd) : null));
    }
  };

  const handlerOpen = () => {
    setIsOpen(!isOpen);
    resetDate();
  };

  const handlerThreeDays = () => {
    setNameSelectDate('day');
    dispatch(setDateStart(getThreeDay()));
    dispatch(setDateEnd(getCurrentDay()));
  };

  const handlerWeek = () => {
    setNameSelectDate('week');
    dispatch(setDateStart(getWeek()));
    dispatch(setDateEnd(getCurrentDay()));
  };

  const handleLastWeek = () => {
    setNameSelectDate('lastWeek');
    dispatch(setDateStart(getLastWeek('start')));
    dispatch(setDateEnd(getLastWeek('end')));
  };

  const handleTwoWeek = () => {
    setNameSelectDate('twoWeek');
    dispatch(setDateStart(getTwoLastWeek()));
    dispatch(setDateEnd(getCurrentDay()));
  };

  const handlerPrevMonth = () => {
    setNameSelectDate(getLastMonth('title') as string);
    dispatch(setDateStart(getLastMonth('start')));
    dispatch(setDateEnd(getLastMonth('end')));
  };

  const handlerBeforeLastMonth = () => {
    setNameSelectDate(getBeforeLastMonth('title') as string);
    dispatch(setDateStart(getBeforeLastMonth('start')));
    dispatch(setDateEnd(getBeforeLastMonth('end')));
  };

  const mapping: Record<number, () => void> = {
    0: handlerThreeDays,
    1: handlerWeek,
    2: handleLastWeek,
    3: handleTwoWeek,
    4: handlerPrevMonth,
    5: handlerBeforeLastMonth,
  };

  useEffect(() => {
    resetDate();
  }, []);

  useEffect(() => {
    const handler = mapping[activeHandlerDate];
    if (handler) {
      handler();
    }
  }, [activeHandlerDate]);

  const DateMenu = () => {
    return (
      <div className={styles.menu} onClick={(e) => e.stopPropagation()}>
        <ul className={styles.list}>
          <li
            className={classNames(
              styles.item,
              nameSelectDate === 'day' ? styles.item_active : '',
            )}
            onClick={handlerThreeDays}>
            3 дня
          </li>
          <li
            className={classNames(
              styles.item,
              nameSelectDate === 'week' ? styles.item_active : '',
            )}
            onClick={handlerWeek}>
            Неделя
          </li>
          <li
            className={classNames(
              styles.item,
              nameSelectDate === 'lastWeek' ? styles.item_active : '',
            )}
            onClick={handleLastWeek}>
            Прошлая неделя
          </li>
          <li
            className={classNames(
              styles.item,
              nameSelectDate === 'twoWeek' ? styles.item_active : '',
            )}
            onClick={handleTwoWeek}>
            Две недели
          </li>
          <li
            className={classNames(
              styles.item,
              nameSelectDate === getLastMonth('title') ? styles.item_active : '',
            )}
            onClick={handlerPrevMonth}>
            {capitalizeFirstLetter(getLastMonth('title') as string)}
          </li>
          <li
            className={classNames(
              styles.item,
              nameSelectDate === getBeforeLastMonth('title') ? styles.item_active : '',
            )}
            onClick={handlerBeforeLastMonth}>
            {capitalizeFirstLetter(getBeforeLastMonth('title') as string)}
          </li>
        </ul>
        <div className={styles.date}>
          <DatePickerСhoose
            setOpenDateFilter={setIsOpen}
            setNameSelectDate={setNameSelectDate}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const clickOutside = (event: MouseEvent) => {
      if (dateRef.current && !event.composedPath().includes(dateRef.current)) {
        setIsOpen(false);
      }
    };
    document.body.addEventListener('click', clickOutside);
    return () => document.body.removeEventListener('click', clickOutside);
  }, []);

  return (
    <div className={styles.root} ref={dateRef} onClick={handlerOpen}>
      <div className={styles.root_blockSelect}>
        <div>
          <CalendarSvg />
          <span ref={dateTitleRef} className={styles.range}>
            {nameSelectDate === 'day'
              ? '3 дня'
              : getTitleDateNewFormat(dateStart, dateEnd)}
          </span>
        </div>
      </div>
      {isOpen && <DateMenu />}
    </div>
  );
});
